(function ($) {
    'use strict';

    function initUsersTable() {
        const tableElement = document.getElementById('adminTenantTable');
        if (!tableElement) {
            return;
        }

        new DataTable('#adminTenantTable', {
            pageLength: 25,
            order: [[1, 'asc']],
            responsive: false,
            autoWidth: false,

            layout: {
                topStart: {
                    buttons: [
                        {
                            extend: 'collection',
                            text: '<i class="bi bi-download me-1"></i>Export',
                            attr: {class: 'btn btn-sm btn-outline-secondary'},
                            buttons: [
                                {
                                    extend: 'copyHtml5',
                                    text: '<i class="bi bi-clipboard me-1"></i>Copy',
                                    exportOptions: {
                                        columns: ':not(:last-child)'
                                    }
                                },
                                {
                                    extend: 'csvHtml5',
                                    text: '<i class="bi bi-filetype-csv me-1"></i>CSV',
                                    exportOptions: {
                                        columns: ':not(:last-child)'
                                    }
                                },
                                {
                                    extend: 'excelHtml5',
                                    text: '<i class="bi bi-file-earmark-excel me-1"></i>Excel',
                                    exportOptions: {
                                        columns: ':not(:last-child)'
                                    }
                                },
                                {
                                    extend: 'pdfHtml5',
                                    text: '<i class="bi bi-file-earmark-pdf me-1"></i>PDF',
                                    exportOptions: {
                                        columns: ':not(:last-child)'
                                    },
                                    orientation: 'landscape',
                                    pageSize: 'A4'
                                },
                                {
                                    extend: 'print',
                                    text: '<i class="bi bi-printer me-1"></i>Print',
                                    exportOptions: {
                                        columns: ':not(:last-child)'
                                    }
                                }
                            ]
                        },
                        {
                            extend: 'colvis',
                            text: '<i class="bi bi-layout-three-columns me-1"></i>Columns',
                            attr: {class: 'btn btn-sm btn-outline-secondary'}
                        }
                    ]
                },
                topEnd: {
                    search: {
                        placeholder: 'Search users'
                    }
                },
                bottomStart: 'info',
                bottomEnd: 'paging'
            }
        });
    }


    $(function () {
        initUsersTable();
    });

})(jQuery);